import React from 'react';

export const Logo = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="200" viewBox="0 0 212 393.725">
            <g
                id="Rectangle_6"
                data-name="Rectangle 6"
                transform="matrix(1, 0.017, -0.017, 1, 7.912, 90.28)"
                fill="#f8f8ff"
                stroke="#6f6f6f"
                strokeLinecap="round"
                strokeWidth="3"
            >
                <rect width="200" height="300" rx="60" stroke="none" />
                <rect x="1.5" y="1.5" width="197" height="297" rx="58.5" fill="none" />
            </g>
            <g
                id="Ellipse_15"
                data-name="Ellipse 15"
                transform="translate(0 72)"
                fill="#dde4f8"
                stroke="#6f6f6f"
                strokeWidth="2"
            >
                <ellipse cx="106" cy="68.5" rx="106" ry="68.5" stroke="none" />
                <ellipse cx="106" cy="68.5" rx="105" ry="67.5" fill="none" />
            </g>
            <g
                id="Ellipse_16"
                data-name="Ellipse 16"
                transform="translate(122)"
                fill="#fff"
                stroke="#000"
                strokeWidth="2"
            >
                <ellipse cx="16" cy="9" rx="16" ry="9" stroke="none" />
                <ellipse cx="16" cy="9" rx="15" ry="8" fill="none" />
            </g>
            <g
                id="Ellipse_17"
                data-name="Ellipse 17"
                transform="translate(42 295)"
                fill="#e2ece9"
                stroke="#e2ece9"
                strokeWidth="1"
            >
                <circle cx="12.5" cy="12.5" r="12.5" stroke="none" />
                <circle cx="12.5" cy="12.5" r="12" fill="none" />
            </g>
            <g
                id="Ellipse_18"
                data-name="Ellipse 18"
                transform="translate(38 341)"
                fill="#b1beed"
                stroke="#b1beed"
                strokeWidth="1"
            >
                <circle cx="12.5" cy="12.5" r="12.5" stroke="none" />
                <circle cx="12.5" cy="12.5" r="12" fill="none" />
            </g>
            <g
                id="Ellipse_19"
                data-name="Ellipse 19"
                transform="translate(67 316)"
                fill="#dde4f8"
                stroke="#dde4f8"
                strokeWidth="1"
            >
                <circle cx="12.5" cy="12.5" r="12.5" stroke="none" />
                <circle cx="12.5" cy="12.5" r="12" fill="none" />
            </g>
            <g
                id="Ellipse_20"
                data-name="Ellipse 20"
                transform="translate(99 345)"
                fill="#e2ece9"
                stroke="#e2ece9"
                strokeWidth="1"
            >
                <circle cx="12.5" cy="12.5" r="12.5" stroke="none" />
                <circle cx="12.5" cy="12.5" r="12" fill="none" />
            </g>
            <g
                id="Ellipse_21"
                data-name="Ellipse 21"
                transform="translate(115 312)"
                fill="#b1beed"
                stroke="#b1beed"
                strokeWidth="1"
            >
                <circle cx="12.5" cy="12.5" r="12.5" stroke="none" />
                <circle cx="12.5" cy="12.5" r="12" fill="none" />
            </g>
            <g
                id="Ellipse_22"
                data-name="Ellipse 22"
                transform="translate(143 287)"
                fill="#dde4f8"
                stroke="#dde4f8"
                strokeWidth="1"
            >
                <circle cx="12.5" cy="12.5" r="12.5" stroke="none" />
                <circle cx="12.5" cy="12.5" r="12" fill="none" />
            </g>
            <g
                id="Ellipse_23"
                data-name="Ellipse 23"
                transform="translate(150 333)"
                fill="#fee4e7"
                stroke="#fee4e7"
                strokeWidth="1"
            >
                <circle cx="12.5" cy="12.5" r="12.5" stroke="none" />
                <circle cx="12.5" cy="12.5" r="12" fill="none" />
            </g>
            <g
                id="Ellipse_24"
                data-name="Ellipse 24"
                transform="translate(84 283)"
                fill="#fee4e7"
                stroke="#fee4e7"
                strokeWidth="1"
            >
                <circle cx="12.5" cy="12.5" r="12.5" stroke="none" />
                <circle cx="12.5" cy="12.5" r="12" fill="none" />
            </g>
            <g id="Group_2" data-name="Group 2" transform="translate(-474 -294)">
                <g
                    id="Subtraction_1"
                    data-name="Subtraction 1"
                    transform="translate(481.594 300.723)"
                    fill="#fff"
                    strokeLinecap="round"
                >
                    <path
                        d="M 89.90641784667969 190.7770233154297 C 78.41068267822266 190.7770233154297 67.25991821289062 189.2500305175781 56.76386642456055 186.2384490966797 C 51.72171783447266 184.791748046875 46.85902786254883 183.0013427734375 42.31087875366211 180.9169311523438 C 37.80862808227539 178.8535919189453 33.57563018798828 176.4844818115234 29.72946739196777 173.8753967285156 C 25.88675498962402 171.2686309814453 22.39888000488281 168.401123046875 19.36274147033691 165.3525543212891 C 16.30130386352539 162.2785339355469 13.67261695861816 158.9935302734375 11.54970455169678 155.5887451171875 C 9.390592575073242 152.1259460449219 7.732729434967041 148.5034332275391 6.622167110443115 144.8218383789062 C 5.483654499053955 141.0477294921875 4.906392097473145 137.1636199951172 4.906392097473145 133.2774047851562 C 4.906392097473145 126.6419219970703 6.565254688262939 120.136962890625 9.836904525756836 113.9432373046875 C 12.93333339691162 108.0812225341797 17.40196228027344 102.6234512329102 23.12273025512695 97.71499633789062 L 27.60897064208984 103.6683883666992 C 22.68140983581543 107.8518371582031 18.83513259887695 112.473747253418 16.1719913482666 117.4126129150391 C 13.34162998199463 122.6615753173828 11.90650463104248 128.1673278808594 11.90650463104248 133.7769012451172 C 11.90650463104248 140.4703369140625 13.93090438842773 146.966064453125 17.9234676361084 153.0836334228516 C 19.83785438537598 156.0169525146484 22.20736694335938 158.8487548828125 24.96616744995117 161.5003814697266 C 27.69364166259766 164.1219177246094 30.82704162597656 166.5919342041016 34.27935409545898 168.8418426513672 C 41.26719284057617 173.3959655761719 49.41825485229492 177.0040435791016 58.50614166259766 179.5658874511719 C 67.81680297851562 182.1904754638672 77.72650909423828 183.6018371582031 87.96327209472656 183.7615814208984 L 93.21730041503906 190.7340240478516 C 92.11379241943359 190.7625885009766 91.00400543212891 190.7770233154297 89.90641784667969 190.7770233154297 Z"
                        stroke="none"
                    />
                    <path
                        d="M 89.90641784667969 190.2770233154297 C 90.67728424072266 190.2770233154297 91.45427703857422 190.2698669433594 92.23078918457031 190.2556915283203 L 87.71088409423828 184.2574615478516 C 77.51766204833984 184.0785064697266 67.64852142333984 182.6625213623047 58.37047958374023 180.047119140625 C 49.23387908935547 177.4715576171875 41.03659057617188 173.8424987792969 34.00635528564453 169.2607421875 C 30.52784156799316 166.9937438964844 27.36970520019531 164.5040740966797 24.61969184875488 161.8608703613281 C 21.83361625671387 159.1830291748047 19.43980407714844 156.3218841552734 17.50474166870117 153.3569030761719 C 13.45825481414795 147.1566925048828 11.40650463104248 140.5690307617188 11.40650463104248 133.7769012451172 C 11.40650463104248 128.0835571289062 12.86177921295166 122.4979858398438 15.73190498352051 117.1753082275391 C 18.35962104797363 112.3021240234375 22.12333488464355 107.7368316650391 26.92685699462891 103.5940246582031 L 23.04525947570801 98.44300842285156 C 17.56500625610352 103.2197265625 13.27306938171387 108.5085525512695 10.27901744842529 114.1767578125 C 7.045779705047607 120.2977752685547 5.406392097473145 126.7241592407227 5.406392097473145 133.2774047851562 C 5.406392097473145 137.1146697998047 5.976491928100586 140.9501953125 7.100854396820068 144.6774291992188 C 8.19867992401123 148.3167724609375 9.838229179382324 151.8988647460938 11.97397994995117 155.32421875 C 14.07700443267822 158.6970520019531 16.68212890625 161.9523620605469 19.71701622009277 164.9997100830078 C 22.73068046569824 168.0257415771484 26.19379234313965 170.8727264404297 30.01016616821289 173.4616088867188 C 33.83344268798828 176.05517578125 38.04207992553711 178.4105834960938 42.51919174194336 180.46240234375 C 47.04462814331055 182.5363922119141 51.88362884521484 184.3180236816406 56.90176773071289 185.7578430175781 C 67.35296630859375 188.7565460205078 78.45732879638672 190.2770233154297 89.90641784667969 190.2770233154297 M 89.90641784667969 191.2770233154297 C 78.36400604248047 191.2770233154297 67.16683959960938 189.7434997558594 56.62596893310547 186.7190551757812 C 51.55987930297852 185.2654876708984 46.67350387573242 183.46630859375 42.10256576538086 181.3714752197266 C 37.57516860961914 179.2966156005859 33.31782913208008 176.9137878417969 29.44878005981445 174.2891693115234 C 25.57975387573242 171.6645660400391 22.06711769104004 168.7765655517578 19.00846672058105 165.7053680419922 C 15.92051696777344 162.604736328125 13.26826667785645 159.2900238037109 11.12541675567627 155.8533020019531 C 8.94297981262207 152.3530731201172 7.266792297363281 148.6901245117188 6.143466949462891 144.9662322998047 C 4.990829467773438 141.1452789306641 4.406392097473145 137.2125854492188 4.406392097473145 133.2774047851562 C 4.406392097473145 126.5596466064453 6.084742069244385 119.9761352539062 9.394792556762695 113.7097015380859 C 12.59360504150391 107.6538619995117 17.23922920227051 102.0286254882812 23.20266723632812 96.99026489257812 L 28.29330444335938 103.7457122802734 C 23.24054145812988 107.9681396484375 19.31045532226562 112.6457366943359 16.61209297180176 117.6499252319336 C 13.82146739959717 122.8251724243164 12.40650463104248 128.2510833740234 12.40650463104248 133.7769012451172 C 12.40650463104248 140.3716583251953 14.40355491638184 146.7754364013672 18.3421802520752 152.8103637695312 C 20.23589134216309 155.7119903564453 22.58109283447266 158.5144500732422 25.31265449523926 161.139892578125 C 28.01755523681641 163.7397308349609 31.12623023986816 166.1901092529297 34.55235290527344 168.4229583740234 C 41.497802734375 172.9494476318359 49.60268020629883 176.5365447998047 58.64180374145508 179.0846405029297 C 67.98499298095703 181.7184143066406 77.93496704101562 183.1249542236328 88.21530151367188 183.2652130126953 L 94.1983642578125 191.2051391601562 C 92.75795745849609 191.2533721923828 91.31419372558594 191.2770233154297 89.90641784667969 191.2770233154297 Z"
                        stroke="none"
                        fill="#fff"
                    />
                </g>
                <path
                    id="Path_1"
                    data-name="Path 1"
                    d="M570.016,484.486s4.585-.509,4.7,3.188c.1,3.162-3,3.691-4.68,3.783h-.024v-6.972Z"
                    transform="translate(4.984 0.033)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="1"
                />
                <g
                    id="Rectangle_4"
                    data-name="Rectangle 4"
                    transform="translate(569 484)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="1"
                >
                    <rect width="6" height="8" stroke="none" />
                    <rect x="0.5" y="0.5" width="5" height="7" fill="none" />
                </g>
                <path
                    id="Path_2"
                    data-name="Path 2"
                    d="M0,.026s3.972-.551,4.075,3.45C4.164,6.9,1.474,7.47.021,7.57c.094,0-.021,0-.021,0V.026Z"
                    transform="matrix(0.809, -0.588, 0.588, 0.809, 512.876, 391.714)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="1"
                />
                <g
                    id="Rectangle_5"
                    data-name="Rectangle 5"
                    transform="translate(503.797 398.506) rotate(-39)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="1"
                >
                    <rect width="11" height="8.5" stroke="none" />
                    <rect x="0.5" y="0.5" width="10" height="7.5" fill="none" />
                </g>
            </g>
            <g
                id="Rectangle_7"
                data-name="Rectangle 7"
                transform="matrix(0.966, 0.259, -0.259, 0.966, 123.334, 5.333)"
                fill="#f8f8ff"
                stroke="#6f6f6f"
                strokeLinecap="round"
                strokeWidth="2"
            >
                <rect width="30" height="130" stroke="none" />
                <rect x="1" y="1" width="28" height="128" fill="none" />
            </g>
            <g
                id="Ellipse_25"
                data-name="Ellipse 25"
                transform="translate(89 126)"
                fill="#f8f8ff"
                stroke="#f8f8ff"
                strokeWidth="2"
            >
                <ellipse cx="16.5" cy="8" rx="16.5" ry="8" stroke="none" />
                <ellipse cx="16.5" cy="8" rx="15.5" ry="7" fill="none" />
            </g>
            <g
                id="Ellipse_26"
                data-name="Ellipse 26"
                transform="translate(122)"
                fill="#f8f8ff"
                stroke="#6f6f6f"
                strokeWidth="2"
            >
                <ellipse cx="16" cy="9" rx="16" ry="9" stroke="none" />
                <ellipse cx="16" cy="9" rx="15" ry="8" fill="none" />
            </g>
        </svg>
    );
};
